export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100">
        <div className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(var(--primary-500)) 0%, transparent 50%), radial-gradient(circle at 80% 20%, oklch(var(--accent-500)) 0%, transparent 40%)',
          }}
        />
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-6">
              <i className="ri-flashlight-line text-sm"></i>
              <span>免费 · 高清 · 不缓冲</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              6789影院 — 热门综艺免费在线观看
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              综艺节目大全每日更新，爆笑综艺、音乐选秀、真人秀全收录。6789影院汇聚全网热门综艺资源，高清画质即点即播，流畅不缓冲，随时畅享纯粹观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-green-500 inline-block"></span>
                <span>今日已更新 12 档节目</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-group-line text-base text-accent-600"></i>
                <span>30万+ 综艺迷每日访问</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-500">
                <i className="ri-shield-check-line text-base text-accent-600"></i>
                <span>全站免费 · 无需注册</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-foreground-200 hover:border-foreground-400 text-foreground-700 hover:text-foreground-900 font-medium rounded-lg text-sm transition-colors duration-200"
              >
                <i className="ri-grid-line text-lg"></i>
                浏览分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Grand%20Chinese%20variety%20show%20stage%20with%20dramatic%20warm%20red%20and%20gold%20lighting%2C%20multiple%20LED%20screens%20displaying%20entertainment%20content%2C%20professional%20TV%20studio%20production%20quality%2C%20energetic%20atmosphere%2C%20cinematic%20composition%2C%20clean%20elegant%20design&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="6789影院综艺节目精彩舞台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}